<template>
	<section class="widget gallery">
		<h2>{{data.title}}</h2>
		<hooper style="height: auto" :mouseDrag="false" :touchDrag="false" :wheelControl="false">
			<slide v-for="gal in gallery" :key="gal.id">
				<img class="gallery-img clickable" :src="gal.url" @click="imgsrc = gal.url; $modal.show('hello-world')">
			</slide>
			<hooper-navigation slot="hooper-addons"></hooper-navigation>
			<hooper-pagination slot="hooper-addons"></hooper-pagination>
		</hooper>
		<modal name="hello-world"
			transition="nice-modal-fade"
        	classes="image-viewer"
			:reset="true"
			width="60%"
			height="90%">
			<img :src="imgsrc">
		</modal>
	</section>
</template>
<script>
import Vue from "vue"
import {Hooper, Slide, Navigation as HooperNavigation, Pagination as HooperPagination } from 'hooper'
import VModal from 'vue-js-modal'
import 'hooper/dist/hooper.css'
Vue.use(VModal)
export default {
	name: 'galleryWidget',
	components: {
		Hooper,
		Slide,
		HooperNavigation,
		HooperPagination
	},
	props: ['data'],
	computed: {
		gallery(){
			return this.data.images
		}
	},
	data() {
		return {
			imgsrc:''
		}
	},
	methods: {

	}
}

</script>